import { KnmKindCodesEnum } from 'APIPackage/DictionariesModule/enums/KnmKindCodesEnum';
import {
  getActAddressBlockId,
  getActInnLabelBlockId,
  getActOgrnLabelBlockId,
  getActOrganizationNameBlockId,
  getActOrganizationTemplateBlockId,
} from 'KnmErknmPackage/MainModule/constants/knmErknmFieldsElementsIds';
import { IKnmErknmFormAct } from 'KnmErknmPackage/MainModule/interfaces/IKnmErknmFormAct';
import { IKnmErknmOrganizationTemplateSelectOption } from 'KnmErknmPackage/MainModule/interfaces/IKnmErknmOrganizationTemplateSelectOption';
import { FieldBlock } from 'UIPackage/FormModule/components/FieldBlock';

import styles from './ErknmActSubject.module.scss';
import { ErknmSubjectAdd } from './components/ErknmSubjectAdd';

interface IErknmActSubjectProps {
  id: string;
  kindKnmCode: KnmKindCodesEnum | undefined;
  name: string;
  organizationsTemplatesSelectOptions: IKnmErknmOrganizationTemplateSelectOption[] | undefined;
  value: IKnmErknmFormAct;
  isDisabledField: boolean;
}

export const ErknmActSubject = ({
  id,
  kindKnmCode,
  name,
  organizationsTemplatesSelectOptions,
  value,
  isDisabledField,
}: IErknmActSubjectProps) => {
  return (
    <div className={styles.Wrapper}>
      <FieldBlock label={'Сведения о контролируемом лице'} />
      <div className={styles.SubjectAdd}>
        <ErknmSubjectAdd
          id={id}
          watchOnly={isDisabledField}
          kindKnmCode={kindKnmCode}
          organizationsTemplatesSelectOptions={organizationsTemplatesSelectOptions}
          name={name}
          organizationTemplate={value.organizationTemplate}
          organizationTemplateBlockId={getActOrganizationTemplateBlockId(value.listId)}
          inn={value.organization?.inn}
          innLabelBlockId={getActInnLabelBlockId(value.listId)}
          ogrn={value.organization?.ogrn}
          ogrnLabelBlockId={getActOgrnLabelBlockId(id)}
          organizationNameBlockId={getActOrganizationNameBlockId(value.listId)}
          addressBlockId={getActAddressBlockId(value.listId)}
          checkSubjectResult={value.organization?.checkSubjectResult || null}
          isAutocomplete={value.organization?.isAutocomplete}
          subjectType={value.organization?.subjectType}
          kpp={value.organization?.kpp}
          smevRequestStatus={value.organization?.smevRequestStatus}
          rafpNza={value.organization?.rafpNza}
          snils={value.organization?.snils}
          ervkId={value.organization?.ervkId}
          isShowSubjectInfoNow={!value.isNew && !!value.organization}
          listId={value.listId}
        />
      </div>
    </div>
  );
};
